import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import { COLORS, GENE_DAMAGE_KEYS } from "./constants";
import { SingleWithLabelAndHelpText } from "../../../../components/atoms";

const damagePredUrl = "https://www.pnas.org/content/112/44/13615";

const getGeneDamagePredictionResult = (item) => {
  const style = {
    textAlign: "center",
    fontWeight: "bold",
  };

  let damagePredictionResult = {};
  let allResult = null;
  let allResultColor = null;
  const damagePredictionBody = [];

  const header = (
    <thead>
      <tr>
        <th style={style} />
        <th style={style}>Autosomal Recessive / Recessive</th>
        <th style={style}>All</th>
        <th style={style}>Autosomal Dominant / Dominant</th>
      </tr>
    </thead>
  );

  let rowKey = 0;
  for (const key in item) {
    const rowColumns = [];
    let row = null;
    if (key !== "all") {
      Object.entries(item[key]).forEach(([k, v]) => {
        const color = COLORS[v];
        return rowColumns.push(
          <td key={k} className="varsome-text-center" style={{ color }}>
            {v}
          </td>
        );
      });
      row = (
        <tr key={rowKey}>
          <td>{GENE_DAMAGE_KEYS[key]}</td>
          {rowColumns}
        </tr>
      );

      damagePredictionBody.push(row);

      rowKey += 1;
    } else {
      allResultColor = COLORS[item[key]];
      allResult = item[key];
    }
  }

  damagePredictionResult = (
    <div>
      <p>
        <strong>
          All: <span style={{ color: allResultColor }}>{allResult}</span>
        </strong>
      </p>
      <table className="varsome-table">
        {header}
        <tbody className="varsome-text-center">{damagePredictionBody}</tbody>
      </table>
    </div>
  );

  return damagePredictionResult;
};

const GeneDamagePredictionResult = ({ item }) => {
  const damagePredictionResult = (
    <div>
      <h5>
        <a href={getVarsoUrl(damagePredUrl)} target="_blank">
          Gene damage prediction
        </a>
      </h5>
      {(item.gdi || item.gdi_phred) && (
        <div className="varsome-horiz-flex">
          <SingleWithLabelAndHelpText
            item={item}
            prop="gdi"
            label="Gene damage index score"
            crop={true}
            numDigits={3}
          />
          <SingleWithLabelAndHelpText
            item={item}
            prop="gdi_phred"
            label="Phred-scaled GDI scores"
            crop={true}
            numDigits={3}
          />
        </div>
      )}
      {getGeneDamagePredictionResult(item.gene_damage_prediction)}
    </div>
  );

  return damagePredictionResult;
};

const { string, shape, arrayOf } = PropTypes;

GeneDamagePredictionResult.propTypes = {
  item: shape({
    mgi_mouse_gene: string,
    mgi_mouse_phenotype: arrayOf(string),
  }),
};

GeneDamagePredictionResult.defaultProps = {
  item: null,
};
export default GeneDamagePredictionResult;
